@use "variables" as *;

.container {
  height: 100%;
  width: 100%;
  display: flex;
  align-self: flex-start;
  flex-direction: column;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.nameField {
  width: 600px;
  height: 100px;
}

.toolbar {
  height: 10%;
  margin-bottom: $spacing-m;
}

.orderByCard {
  margin: $spacing-s $spacing-xl;
  padding: $spacing-m;
  flex-shrink: 0;
  border-radius: 12px !important;
}

.orderTitle {
  font-size: $fontSize-xs;
  font-weight: bold;
  margin-bottom: $spacing-xs;
}

.description {
  font-size: $fontSize-s;
  text-align: center;
  padding-left: $spacing-xl;
  padding-right: $spacing-xl;
}

.listItem {
  padding: $spacing-s $spacing-m $spacing-s 0 !important;
}

.filterElementTitle {
  font-size: $fontSize-s;
  font-weight: bold;
  margin-bottom: $spacing-xs;
}

.filterComponent {
  width: 100%;
}

.filterComponentTitle {
  font-size: $fontSize-m;
  border-radius: 4px !important;
}

.genericFilterTitle {
  padding: $spacing-xs $spacing-s;
}

.filterToggle {
  font-size: $fontSize-m;
  padding: $fontSize-xs;
}

.boxHeader {
  position: sticky;
  top: 0;
  z-index: 100;
  font-size: $fontSize-xs;
  text-align: center;
  font-weight: bold;
}

.applyButton {
  flex-grow: 1;
}

.itemTitleStack {
  margin-bottom: $spacing-xs;
}

.itemIcon {
  font-size: $fontSize-m !important;
}
